import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';
import { useDataStore } from '../stores/dataStore';
import { isSoloUser } from '../auth/schoolContext';

export default function DataProvider({ children }) {
  const [user] = useAuthState(auth);
  const [userType, setUserType] = useState(null); // 'solo' | 'school' | null
  const subscribeStudents = useDataStore((s) => s.subscribeStudents);
  const subscribeInterventions = useDataStore((s) => s.subscribeInterventions);
  const unsubscribeAll = useDataStore((s) => s.unsubscribeAll);

  // Detect user type when user changes
  useEffect(() => {
    async function checkUserType() {
      if (!user) {
        setUserType(null);
        return;
      }
      
      const solo = await isSoloUser();
      setUserType(solo ? 'solo' : 'school');
    }
    
    checkUserType();
  }, [user]);

  useEffect(() => {
    if (!user) {
      console.log('DataProvider: No user, unsubscribing all');
      unsubscribeAll();
      return;
    }
    
    // Wait until we know the user type
    if (userType === null) {
      return;
    }
    
    // Solo users don't need school-specific subscriptions (students, interventions)
    // They only access the knowledge base which doesn't require realtime subscriptions
    if (userType === 'solo') {
      console.log('DataProvider: Solo user detected, skipping school subscriptions', user.email);
      return;
    }
    
    console.log('DataProvider: School user authenticated, starting subscriptions', user.email);
    // Start core subscriptions only for school users
    const unsubs = [subscribeStudents(), subscribeInterventions()];
    
    return () => {
      console.log('DataProvider: Cleaning up subscriptions');
      unsubs.forEach((fn) => { try { fn && fn(); } catch { /* noop */ } });
    };
  }, [user, userType]); // Include userType to re-run when detected

  return children;
}

